module.exports = __webpack_public_path__ + "static/media/grindavikurvegur.f6e82139.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/grindavikurvegur.png
 ** module id = 194
 ** module chunks = 0
 **/